<div class="container">
  <section class="header">
    <span>RECORDING JOB SETTINGS</span>
    <div
      class="close"
      inlineSVG="/assets/icons/close.svg"
      (click)="closeWindow()"
    ></div>
  </section>
  <section class="settings">
    <div #settingsPanel class="settings-panel">
      <div #sectionGeneral class="section">General</div>
      <div class="property">
        <span class="label">Job Name</span>
        <input
          class="value"
          type="text"
          [(ngModel)]="recordingJob.name"
          placeholder="Name your recording job"
          (input)="missingNameError = false"
        />
        <small *ngIf="missingNameError">* recording job must have a name</small>
      </div>
      <div class="property">
        <span class="label">Start Time</span>
        <evrideo-date-time-picker
          class="value"
          [date]="tempStartTime.clone()"
          (dateChanged)="onStartTimeChanged($event)"
        ></evrideo-date-time-picker>
        <small *ngIf="startTimeError"
          >* start date cannot be in the past or after end date</small
        >
      </div>
      <div class="property">
        <span class="label">End Time</span>
        <evrideo-date-time-picker
          class="value"
          [date]="tempEndTime.clone()"
          (dateChanged)="onEndTimeChanged($event)"
        >
        </evrideo-date-time-picker>
        <small *ngIf="endTimeError"
          >* end date cannot be before start date</small
        >
      </div>
      <div #sectionSources class="section">Recording Sources</div>
      <div
        class="dropbox"
        [ngClass]="{ 'on-drag': onDrag }"
        (dragover)="$event.preventDefault()"
        (dragenter)="onDragEnter()"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
      >
        <span>Drag here!</span>
      </div>
      <div class="sources">
        <ng-container
          *ngIf="
            recordingJob.recordingSources.length > 0;
            then sources;
            else empty
          "
        ></ng-container>
        <ng-template #sources>

          <div
            *ngFor="let source of recordingJob.recordingSources"
            class="source"
            [ngClass]="{ edited: !!source.mediaUniqueIdTemplate}"
          >
            <label contenteditable="true" (keydown)="onEditSourceNameKeyDown($event)" (blur)="onSourceEdited($event, source)">{{ source.mediaUniqueIdTemplate || source.name }}</label>
            <span *ngIf="getPlatformName(source) as platformName" class="platform-name">&nbsp;({{ platformName }})</span>
            <div
              *ngIf="platformPickerSource === source"
              class="platform-picker"
              (click)="$event.stopPropagation()"
            >
              <header>Select streaming platform</header>
              <div *ngIf="isPlatformPickerLoading()" class="loading">
                Loading...
              </div>
              <icn-dropdown
                *ngIf="!isPlatformPickerLoading()"
                [selectedValue]="platformPickerSelection"
                (selectedValueChange)="platformPickerSelection = $event"
                [short]="true"
                [listDown]="true"
              >
                <icn-dropdown-item
                  *ngFor="let p of platformPickerPlatforms"
                  [value]="p.id"
                  [title]="p.availabilityZoneName"
                ></icn-dropdown-item>
              </icn-dropdown>
              <footer>
                <button class="cancel" (click)="closePlatformPicker()">
                  Cancel
                </button>
                <button class="save" (click)="savePlatformPicker()">
                  Save
                </button>
              </footer>
            </div>
            <div class="source-buttons">
              <div
                _ngcontent-c27=""
                class="remove"
                (click)="removeSource(source)"
              >
                <svg
                  _ngcontent-c27=""
                  height="7px"
                  viewBox="0 0 12 12"
                  width="7px"
                >
                  <path
                    _ngcontent-c27=""
                    d="M10.943,9.919 L9.888,10.974 L5.939,7.024 L1.990,10.974 L0.934,9.919 L4.884,5.969 L0.934,2.020 L1.990,0.965 L5.939,4.914 L9.888,0.965 L10.943,2.020 L6.994,5.969 L10.943,9.919 Z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </div>
              <div
                *ngIf="source.type === recordingSourceType.LiveFeed"
                class="source-gear"
                inlineSVG="/assets/icons/settings.svg"
                (click)="openPlatformPicker(source)"
              ></div>
            </div>
          </div>

          <div class="edit-video-id-message">Double click on a source to edit the target media video Id</div>
        </ng-template>
        <ng-template #empty>
          <div class="empty">Drag a source from your sources panel</div>
        </ng-template>
      </div>
      <small *ngIf="recordingSourcesError">* must select at least one recording source</small>
      <small *ngIf="recordingSourcesNotValidIdError">{{recordingSourcesNotValidIdError}}</small>
    </div>
    <div class="aside">
      <ul>
        <li (click)="scrollSectionIntoView('general')">General</li>
        <li (click)="scrollSectionIntoView('sources')">Recording Sources</li>
      </ul>
    </div>
  </section>
  <section class="footer">
    <div class="btn-save" (click)="saveAndCloseWindow()">
      <span>Save</span>
    </div>
  </section>
</div>
